import React from 'react'

function CommunityAgreementIT() {
  return (
    <>
      <p className="heading-1">
        Accordo per l'assegnazione dei diritti sui Contenuti generati del
        Creator
      </p>

      <div className="paragraph-2">
        <p>
          Skeepers è una società per azioni semplificata con un capitale di
          11.470.723 euro, iscritta al Registro del Commercio e delle Società di
          Marsiglia con il numero 879 038 990, la cui sede legale si trova
          all’indirizzo 18-20 Avenue Robert Schuman, CS 40494, 13002 Marsiglia,
          Francia.
        </p>
        <p>
          Nel presente Contratto, il termine "Skeepers" indica Skeepers e le sue
          affiliate. Tutti i termini in maiuscolo sono definiti nei T&C
          Skeepers.
        </p>
        <p>
          Pubblicando contenuti sul Sito, l'utente riconosce e accetta
          espressamente di assegnare a Skeepers, alle condizioni definite di
          seguito, tutti i diritti che detiene sui Contenuti creati (in
          conformità con i Termini Skeepers, il termine "Contenuto" si riferisce
          ai testi, immagini, fotografie, disegni, avatar e più in generale
          qualsiasi pubblicazione visiva, testuale, sonora o grafica del
          Creator, che rappresenta i Prodotti, distribuiti come parte dei
          servizi), e autorizzano espressamente Skeepers a utilizzare l'immagine
          dell'utente alle condizioni specificate di seguito:
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          1. Cessione dei diritti sui contenuti
        </p>
        <p>
          In considerazione della proprietà del Prodotto ricevuto, l'utente
          assegna espressamente e in via non esclusiva a Skeepers tutti i propri
          diritti sul Contenuto, incluso il diritto per Skeepers di:
        </p>
        <ul className="paragraph-2">
          <li>
            utilizzare, riprodurre, concedere in sublicenza, assegnare,
            distribuire, temporaneamente o durevolmente, mettere in
            circolazione, estrarre, scaricare, archiviare, elencare,
            classificare in una banca dati, comunicare al pubblico,
            rappresentare, sfruttare il Contenuto su tutti i formati e su tutti
            i supporti conosciuti o sconosciuti fino ad oggi e in particolare
            senza che questo elenco sia esaustivo, su Internet indipendentemente
            dall'estensione generica, geografica o del nome di dominio del sito
            Web interessato e dal paese di ricezione del Contenuto (in
            particolare sulla piattaforma e sul sito di Skeepers, sui suoi
            social network come Facebook, Twitter, Instagram, IGTV, Snapchat, su
            siti che condividono registrazioni audiovisive come YouTube,
            Dailymotion, Pinterest, ma anche Weibo, WeChat e, in generale, su
            qualsiasi altro mezzo esistente o futuro), da qualsiasi forma di
            trasmissione come cinema, televisione terrestre, satellite,
            operatore via cavo, DTT e qualsiasi processo esistente o futuro, in
            Francia e all'estero
          </li>
          <li>
            apportare al Contenuto qualsiasi modifica, totale o parziale, di
            tipo aggiunta, cancellazione, adattamento, traduzione, declinazione,
            editing e doppiaggio in una lingua diversa dalla lingua francese;
            estrarre tutto o parte del Contenuto dappertutto nel mondo e su
            qualsiasi modalità appropriata di sfruttamento e su qualsiasi
            supporto. I Contenuti trasferiti possono anche essere adattati e/o
            tradotti per consentirne l'integrazione in un'altra opera
            audiovisiva, multimediale e/o digitale e su tutti i supporti sopra
            definiti
          </li>
          <li>
            concedere alcuni o tutti i diritti assegnati dall'utente ai sensi
            del presente Contratto. In particolare, il diritto di rappresentare
            e distribuire i Contenuti dell'utente può essere concesso, tramite
            una sublicenza, su tutti i supporti e in tutti i formati e in
            particolare:
            <ul className="paragraph-2">
              <li>
                su Internet (in particolare sul sito web del Cliente e/o sui
                social network, come Facebook, Twitter, Instagram, IGTV,
                Snapchat, su siti di condivisione di registrazioni audiovisive
                come YouTube Dailymotion, Pinterest, ma anche Weibo, WeChat e,
                in generale, su qualsiasi altro mezzo esistente o futuro),
                tramite qualsiasi forma di distribuzione come cinema,
                televisione terrestre, satellite, operatore via cavo, DTT e
                qualsiasi processo esistente o futuro, in Francia e all'estero,
                sui siti di e-commerce su cui il Cliente offre i suoi prodotti
                in vendita, indipendentemente dal fatto che sia o meno l'editore
                del sito di e-commerce e indipendentemente dall’estensione
                generica, geografica o del nome di dominio del sito Web del
                Cliente, e il paese di ricezione del Contenuto
              </li>
              <li>
                sui luoghi fisici di vendita del Cliente (negozi, corner),
                fiere, mostre, luoghi di pubblicità, mostre e qualsiasi altro
                evento pubblico in cui il Cliente sarà presente o rappresentato
              </li>
              <li>
                internamente a beneficio dei soci e dei dipendenti del Cliente
              </li>
            </ul>
          </li>
        </ul>
        <p>
          Questa assegnazione consente a Skeepers di sfruttare tali Contenuti
          sia per scopi di comunicazione esterna e interna, sia per scopi
          gratuiti, promozionali, pubblicitari, eventi, commerciali e di lucro,
          in particolare commercializzando e/o mettendo a disposizione dei
          propri Clienti, direttamente o tramite terzi autorizzati da Skeepers,
          prodotti o servizi.
        </p>
        <p>
          Tale cessione di diritti è concessa dal giorno dell'accettazione del
          presente contratto e per la durata legale della protezione dei
          diritti. Il presente incarico è concesso in tutto il mondo.
        </p>
        <p>
          Per quanto riguarda i diritti morali dell'utente, il diritto di
          adattare il Contenuto consentirà a Skeepers di apportarvi modifiche,
          come qualsiasi modifica resa necessaria a causa di vincoli tecnici o
          che consentano l'implementazione del Contenuto in qualsiasi forma e
          mezzo scelto da Skeepers su cui il Contenuto sarà riprodotto o
          rappresentato. Non sarà possibile opporsi o contestare tali modifiche,
          e neanche richiedere un compenso o un risarcimento di qualsiasi tipo
          per le suddette modifiche, purché venga rispettata l'integrità del
          lavoro dell’utente.
        </p>
        <p>
          L'utente dichiara e garantisce a Skeepers di essere proprietario
          esclusivo di tutti i diritti assegnati al Contenuto ai sensi del
          presente Contratto. L'utente garantisce pertanto di aver ottenuto, da
          parte di eventuali autori e/o assistenti intervenuti nel contesto
          della produzione del Contenuto e aventi qualsiasi diritto sul
          Contenuto, tutti i diritti e le autorizzazioni necessari che
          consentano di trasferire i diritti di proprietà collegati al Contenuto
          a beneficio di Skeepers, e in particolare i diritti di utilizzare, nel
          caso sia presente, la musica allegata ai Contenuti.
        </p>
        <p>
          L’utente dichiara inoltre che i diritti non sono stati oggetto di
          alcun trasferimento parziale o totale, gratuito o a pagamento, di
          alcuna licenza di qualsiasi tipo, di alcun pegno o diritto di pegno a
          nessuno, né di alcuna controversia in qualsiasi forma, ad eccezione
          della licenza concessa al social network su cui sia stato pubblicato
          il Contenuto.
        </p>
        <p>
          L'utente garantisce il pacifico godimento di tali diritti e accetta di
          indennizzare Skeepers da ogni conseguenza, incluse quelle finanziarie,
          che possano derivare da qualsiasi controversia, reclamo o azione
          intentata da terzi in relazione alla proprietà dei diritti sul
          Contenuto.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Diritti d'immagine</p>
        <p>
          Nella misura in cui l'utente appare nel Contenuto, questi autorizza
          espressamente Skeepers a utilizzare gli attributi di personalità
          (inclusi, a titolo esemplificativo ma non esaustivo, immagine, marchio
          personale, logo personale, cognome, nome e voce) per consentire a
          Skeepers di esercitare i diritti ad essa concessi nel Contenuto in
          conformità con il punto 1 di cui sopra.
        </p>
        <p>
          In considerazione della proprietà del Prodotto ricevuto, l'utente
          autorizza espressamente Skeepers a:
        </p>
        <ul className="paragraph-2">
          <li>
            acquisire, fissare, riprodurre, adattare e diffondere la propria
            immagine (compresi in particolare l’immagine, il brand personale, il
            logo personale, la voce, cognome e nome) su tutti i media di
            riproduzione e diffusione di cui al punto 1), e in particolare su
            Internet, sulla piattaforma e sul sito di Skeepers, sui social
            network come Facebook, Twitter, Instagram, IGTV, Snapchat, su siti
            di condivisione di registrazioni audiovisive come YouTube
            Dailymotion, Pinterest, ma anche Weibo, WeChat e, in generale, su
            qualsiasi altro mezzo esistente o futuro, tramite qualsiasi forma di
            trasmissione come cinema, televisione terrestre, satellite,
            operatore via cavo, DTT e qualsiasi mezzo esistente o futuro, in
            Francia e all'estero, indipendentemente dall'estensione generica,
            geografica o del nome di dominio del sito web interessato e dal
            paese di ricezione del Contenuto
          </li>
          <li>
            concedere ai suoi beneficiari (inclusi produttori, distributori,
            siti web commerciali e più in generale clienti professionisti,
            ecc.), il diritto sub licenziabile di utilizzare gli attributi di
            personalità (quali immagine, marchio e logo personali, cognome, nome
            e voce) su Internet (in particolare sul sito web e/o sui social
            network, come Facebook, Twitter, Instagram, IGTV, Snapchat, su siti
            di condivisione di registrazioni audiovisive come YouTube,
            Dailymotion, Pinterest, ma anche Weibo, WeChat e, in generale, su
            qualsiasi altro mezzo esistente o futuro), tramite qualsiasi forma
            di distribuzione come cinema, televisione terrestre, satellite,
            operatore via cavo, DTT e qualsiasi processo esistente o futuro, in
            Francia e all'estero, sui siti di e-commerce su cui il Cliente offre
            i propri prodotti in vendita, indipendentemente dal fatto che sia o
            meno l'editore del(i) sito(i) di e-commerce e indipendentemente
            dall’estensione generica, geografica o dall'estensione del nome di
            dominio del sito Web del Cliente, e il paese di ricezione del
            Contenuto, presso i luoghi fisici di vendita del Cliente (negozi,
            corner), in occasione di fiere, mostre, luoghi di pubblicità fisica
            e qualsiasi altro evento pubblico in cui il Cliente sarà presente o
            rappresentato internamente a beneficio dei membri e dei dipendenti
            del Cliente.
          </li>
        </ul>
        <p>
          La presente autorizzazione è concessa in tutto il mondo e per un
          periodo di venti (20) anni dalla data di accettazione del presente
          contratto.
        </p>
        <p>
          L'utente dichiara e garantisce di aver ottenuto il consenso scritto
          delle persone raffigurate sul Contenuto, o dei loro rappresentanti
          legali, per l'uso dei loro attributi di personalità (inclusi, a titolo
          esemplificativo ma non esaustivo, immagine, nome, voce) in modo che il
          Contenuto possa essere liberamente utilizzato, distribuito, riprodotto
          e sfruttato da Skeepers e dal suo Cliente alle condizioni stabilite
          nel presente documento. L'utente accetta di giustificare tale
          autorizzazione, senza ritardo, alla prima richiesta di Skeepers.
          L'utente accetta di indennizzare Skeepers da qualsiasi conseguenza che
          possa derivare da qualsiasi controversia, reclamo o azione intentata
          da terzi in relazione all'utilizzo dei suoi attributi di personalità.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Disposizioni comuni</p>
        <p>
          La cessione dei diritti sui Contenuti in conformità al punto 1) e
          l'autorizzazione all'utilizzo dell’immagine, concessa ai sensi del
          punto 2), è consentita per lo sfruttamento, il funzionamento e la
          promozione istituzionale e pubblicitaria da parte di Skeepers del suo
          sito, piattaforma e attività, nonché la promozione istituzionale e
          pubblicitaria dei prodotti, servizi e attività dei suoi beneficiari o
          (inclusi produttori, distributori, siti web commerciali e più in
          generale clienti professionista, ecc.).
        </p>
        <p>
          In conformità con l'articolo L.122-7 del Codice della proprietà
          intellettuale, l'utente riconosce e accetta espressamente che la
          presente cessione di diritti e l'autorizzazione all'utilizzo della
          propria immagine sono concesse solo in cambio del prodotto ricevuto.
          L'utente rinuncia a qualsiasi altra forma di corrispettivo, anche
          finanziario.
        </p>
        <p>
          Nel caso in cui, al momento dell'accettazione del presente Contratto,
          l'utente sia minorenne (di età inferiore ai 18 anni), questi dichiara
          e garantisce che Skeepers ha ottenuto l'autorizzazione da parte dei
          genitori o del(i) titolare(i) dell'autorità genitoriale o, in caso
          contrario, del tutore legale al fine dell’accettazione del presente
          Contratto. L'utente accetta di giustificare tale autorizzazione, senza
          ritardo, alla prima richiesta di Skeepers.
        </p>
        <p>
          In caso di conflitto tra il presente Accordo e i termini e le
          condizioni d'uso del Sito e della Piattaforma Skeepers, prevarranno le
          disposizioni del presente Accordo.
        </p>
        <p>
          In caso di annullamento da parte del tribunale o di altra autorità
          competente di qualsiasi disposizione del presente Accordo, tutte le
          altre clausole dello stesso rimarranno in vigore a meno che, a seguito
          della cancellazione della clausola, non diventino irrilevanti o
          impossibili da eseguire.
        </p>
        <p>Il presente Contratto è soggetto alla legge francese.</p>
        <p>
          Nessuna tolleranza da parte di Skeepers di qualsiasi tipo, estensione,
          durata o frequenza sarà considerata come un diritto a beneficio
          dell'utente o essere interpretata come una rinuncia da parte di
          Skeepers a una qualsiasi delle disposizioni del presente Accordo.
        </p>
        <p>
          Per accordo esplicito, le e-mail e i sistemi di registrazione
          automatica utilizzati sul Sito e sulla Piattaforma Skeepers faranno
          fede tra le parti.
        </p>
      </div>
    </>
  )
}

export default CommunityAgreementIT
